import React, { useState } from "react";

// A workspace's agent picture (HUB #337; the server sends it as agentImageUrl, AXOS only for now) filling whatever box
// holds it, or the fallback (the initials) when there is none or it fails to load. The box always sits beside the
// name it stands for, so the picture is decoration with no alt text of its own.
export function AgentPicture({ src, fallback = null }) {
  const [failed, setFailed] = useState(null);
  if (!src || failed === src) return fallback;
  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      decoding="async"
      referrerPolicy="no-referrer"
      draggable={false}
      onError={() => setFailed(src)}
      className="block h-full w-full rounded-[inherit] object-cover"
    />
  );
}
